const COLORS = {
    gray: "#666666",
    lightGray: "#999999",
    darkGray: "#222222",
    lightPink: "#d65e97",
    superLightPink: "rgba(214, 94, 151, 0.1)"
}

export default COLORS;